//import hook react
import React, { useState, useEffect } from 'react';

//import hook useHitory from react router dom
import { useHistory } from 'react-router';

//import axios
import axios from 'axios';

//import component NavBar
import NavBar from '../components/NavBar';

//import component DashboardApp
import DashboardApp from '../components/DashboardApp';

function Dashboard() {

    //state user
    const [user, setUser] = useState([]);

    //define history
    const history = useHistory();

    const fetchUser = async () => {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)}`
        await axios.get(process.env.REACT_APP_API_URL + '/api/user')
            .then((response) => {
                //set token on localStorage
                localStorage.setItem(process.env.REACT_APP_USER_STORAGE, JSON.stringify(response.data));

                setUser(JSON.parse(localStorage.getItem(process.env.REACT_APP_USER_STORAGE)));
            })
            .catch((error) => {
                localStorage.removeItem(process.env.REACT_APP_USER_STORAGE);
            })
    }

    //hook useEffect
    useEffect(() => {
        //check token empty
        if (!localStorage.getItem(process.env.REACT_APP_TOKEN_NAME)) {
            //redirect login page
            history.push('/');
        }

        if (!localStorage.getItem(process.env.REACT_APP_USER_STORAGE)) {
            fetchUser();
        }
        else {
            setUser(JSON.parse(localStorage.getItem(process.env.REACT_APP_USER_STORAGE)));
        }
    }, []);

    return (
        <div className="container" style={{ marginTop: "50px" }}>
            <div className="row justify-content-center">
                <div className="col-md-12">
                    <div className="card border-0 rounded shadow-sm">
                        <div className="card-body">
                            <div className='row'>
                                <div className='col-md-12 text-right'>
                                    <NavBar user={user}></NavBar>
                                </div>
                                <div className='col-md-12'>
                                    <h1>{process.env.REACT_APP_WEBSITE_NAME}</h1>
                                    SELAMAT DATANG, {user.user_type} <strong className="text-uppercase">{user.name}</strong>
                                </div>
                            </div>
                            <hr />
                            <DashboardApp user={user}></DashboardApp>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Dashboard;